import CustomCircularProgressBar from "components/customCharts/customCircularProgressBar";
import LoadingScreen from "components/LoadingScreen";
import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { useEffect, useState } from "react";
import { fetchWatomsCurriculumsPerOrg, fetchWatomsRelatedVtcs } from "services/watoms/watomsData";
import { fetchWatomsWorkshopPerformanceReport } from "services/watoms/watomsReports";

const EbdaEduWatomsWorkshopReport = () => {
    const [vtcs, setVtcs] = useState([]);
    const [workshops, setWorkshops] = useState([]);
    const [filteredWorkshops, setFilteredWorkshops] = useState([]);
    const [teReport, setTeReport] = useState({});
    const [bfReport, setBfReport] = useState({});
    const [selectedVtc, setSelectedVtc] = useState("");
    const [selectedWorkshop, setSelectedWorkshop] = useState("");
    const [loading, setLoading] = useState(true);
    const [reportLoading, setReportLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);

                const [vtcsResponse, workshopsResponse] = await Promise.all([
                    fetchWatomsRelatedVtcs(),
                    fetchWatomsCurriculumsPerOrg()
                ]);

                setVtcs(vtcsResponse);
                setWorkshops(workshopsResponse);
                setFilteredWorkshops(workshopsResponse.total);

            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    useEffect(() => {
        const filterWorkshops = () => {
            let filtered;
            if (selectedVtc === "") {
                filtered = workshops.total;
            } else {
                filtered = workshops[selectedVtc];
            }
            setFilteredWorkshops(filtered);
        }

        filterWorkshops();
    }, [selectedVtc, workshops]);

    useEffect(() => {
        const loadWorkshopPerformanceReportData = async () => {
            try {
                setReportLoading(true);

                const response = await fetchWatomsWorkshopPerformanceReport({
                    vtcs: selectedVtc,
                    workshops: selectedWorkshop,
                });

                setTeReport(response.teReport);
                setBfReport(response.bfReport);
            } catch (error) {
                console.error(error);
            } finally {
                setReportLoading(false);
            }
        };

        loadWorkshopPerformanceReportData();
    }, [selectedVtc, selectedWorkshop]);

    const teScore = teReport?.teTotalScore ?? 0;
    const bfScore = bfReport.teTotalScore ?? 0;
    const avgScore = (teScore * 0.7) + (bfScore * 0.3);
    const classifier = avgScore >= 70 ? 'A' : avgScore >= 55 ? 'B+' : avgScore >= 45 ? 'B' : 'C';
    const classifierColor = classifier === 'A' ? 'bg-green-600' : (classifier === 'B' || classifier === 'B+') ? 'bg-yellow-500' : 'bg-red-600';

    if (loading) return <LoadingScreen />;
    if (reportLoading) return <LoadingScreen />;

    return (
        <div>
            <EbdaEduNavbar />
            <div className="flex items-center justify-center">

                {/* modal */}
                <div className="relative z-50 w-[90%] flex flex-col items-center bg-white rounded-lg p-4">
                    {/* Classifier badge */}
                    <div className="absolute top-4 left-4 flex flex-col items-center">
                        <div
                            className={`${classifierColor} text-white w-14 h-14 rounded-full flex items-center justify-center text-2xl font-bold shadow-lg`}
                        >
                            {classifier}
                        </div>
                        <span className="mt-1 text-sm font-semibold text-gray-700">
                            {Math.round(avgScore)}%
                        </span>
                    </div>

                    <h1 className="text-2xl text-center font-bold text-gray-800 mb-4">
                        تقرير نسبة كفاءة و فاعلية المركز و تحديد المتطلبات
                    </h1>
                    {/* filters */}
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" dir="rtl">
                        {/* VTCs */}
                        <div className="flex flex-col">
                            <label className="text-sm font-bold text-gray-700 mb-1">
                                المراكز
                            </label>
                            <select
                                value={selectedVtc}
                                onChange={(e) => setSelectedVtc(e.target.value)}
                                className="border border-gray-300 rounded-lg px-3 py-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value="">الكل</option>
                                {vtcs.map((vtc) => (
                                    <option key={vtc.id} value={vtc.id}>
                                        {vtc.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Workshops */}
                        <div className="flex flex-col">
                            <label className="text-sm font-bold text-gray-700 mb-1">
                                الورش
                            </label>
                            <select
                                value={selectedWorkshop}
                                onChange={(e) => setSelectedWorkshop(e.target.value)}
                                className="border border-gray-300 rounded-lg px-3 py-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value="">الكل</option>
                                {filteredWorkshops?.map((workshop) => (
                                    <option key={workshop.id} value={workshop.id}>
                                        {workshop.code}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <h1 className="text-xl text-center font-bold text-gray-800 mb-4">
                        اجمالي تقييم استمارة بيئة التدريب
                    </h1>

                    <div className="w-[200px] h-[200px] flex items-center justify-center shrink-0 my-2">
                        <CustomCircularProgressBar value={teReport.teTotalScore || 0} size={200} stroke={20} textColor={"#212738"} />
                    </div>
                    <div className="w-full grid grid-cols-3 gap-2 my-4" dir="rtl">
                        {teReport?.fieldScores?.map((field, idx) => (
                            <div key={idx} className="flex flex-col items-center text-center">
                                <h1 className="text-xl font-bold text-gray-800 mb-4">
                                    {field.fieldName}
                                </h1>
                                <CustomCircularProgressBar value={field.score || 0} size={64} textColor={"#212738"} />
                            </div>
                        ))}
                    </div>

                    <h1 className="text-xl text-end font-bold text-gray-800 mb-4">
                        اجمالي تقييم استمارة الابنية و المرافق
                    </h1>

                    <div className="w-[200px] h-[200px] flex items-center justify-center shrink-0 my-2">
                        <CustomCircularProgressBar value={bfReport.teTotalScore || 0} size={200} stroke={20} textColor={"#212738"} />
                    </div>
                    <div className="w-full grid grid-cols-3 gap-2 my-4" dir="rtl">
                        {bfReport?.fieldScores?.map((field, idx) => (
                            <div key={idx} className="flex flex-col items-center text-center">
                                <h1 className="text-xl font-bold text-gray-800 mb-4">
                                    {field.fieldName}
                                </h1>
                                <CustomCircularProgressBar value={field.score || 0} size={64} textColor={"#212738"} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EbdaEduWatomsWorkshopReport;